export default function Reputation() {
  const reviews = [
    {
      name: '吃瓜群众小明',
      rating: 5,
      text: '黑料入口真的是我每天的快乐源泉！内容更新快、信息全，而且分类很清晰，想找什么类型的瓜都能快速找到。已经推荐给身边所有朋友了！',
      date: '2026-07-05',
    },
    {
      name: '娱乐圈老司机',
      rating: 5,
      text: '用了很多吃瓜平台，黑料入口是体验最好的。界面干净没有乱七八糟的广告，文章质量也很高，很多独家爆料都是在这里首发看到的。强烈推荐！',
      date: '2026-07-03',
    },
    {
      name: '追瓜达人小红',
      rating: 5,
      text: '自从发现了黑料入口，再也不用到处找瓜了。每天打开就能看到最新热点，而且文章的深度分析真的很到位，不是那种标题党。良心平台！',
      date: '2026-07-01',
    },
    {
      name: '理性吃瓜选手',
      rating: 4,
      text: '内容质量和更新速度都很棒，唯一希望的是能增加夜间模式，晚上刷的时候眼睛会舒服一些。总体来说是值得收藏的吃瓜好站。',
      date: '2026-06-28',
    },
  ];

  const trustIndicators = [
    { icon: 'ri-shield-check-line', label: '内容审核', desc: '每条内容经过严格核验' },
    { icon: 'ri-user-heart-line', label: '5000万+', desc: '累计服务用户数' },
    { icon: 'ri-article-line', label: '1万+', desc: '累计发布文章数' },
    { icon: 'ri-star-smile-line', label: '98%', desc: '用户满意度评分' },
  ];

  return (
    <section className="mt-12 pt-10 border-t border-background-200/70">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 flex items-center justify-center bg-accent-100 text-accent-600 rounded-lg">
          <i className="ri-thumb-up-line text-xl"></i>
        </div>
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
          口碑评价
        </h2>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-10">
        {trustIndicators.map((item, index) => (
          <div
            key={index}
            className="bg-background-100 border border-background-200/70 rounded-lg p-4 text-center"
          >
            <div className="w-8 h-8 flex items-center justify-center mx-auto mb-2 text-primary-500">
              <i className={`${item.icon} text-lg`}></i>
            </div>
            <div className="font-heading font-bold text-lg text-foreground-950">{item.label}</div>
            <div className="text-xs text-foreground-500 mt-0.5">{item.desc}</div>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {reviews.map((review, index) => (
          <div
            key={index}
            className="bg-background-50 border border-background-200/70 rounded-lg p-5"
          >
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                  <span className="text-accent-700 font-semibold text-xs">{review.name[0]}</span>
                </div>
                <span className="font-medium text-sm text-foreground-900">{review.name}</span>
              </div>
              <div className="flex items-center gap-0.5">
                {Array.from({ length: 5 }).map((_, i) => (
                  <div key={i} className="w-3.5 h-3.5 flex items-center justify-center">
                    <i
                      className={`text-xs ${
                        i < review.rating
                          ? 'ri-star-fill text-accent-500'
                          : 'ri-star-line text-foreground-300'
                      }`}
                    ></i>
                  </div>
                ))}
              </div>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed mb-2">{review.text}</p>
            <p className="text-xs text-foreground-400">{review.date}</p>
          </div>
        ))}
      </div>
    </section>
  );
}